import { useEffect, useState } from 'react';

const CHUBB_DISABLE_DATE_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2}) HKT$/;
const HKT_OFFSET_HOURS = 8;
const MAX_TIMEOUT_MS = 2147483647;

export const getChubbFunctionDisableTimeUtc = () => {
    const configuredDateTime = process.env.REACT_APP_FUNCTION_DISABLE_FOR_CHUBB;
    const match = configuredDateTime?.match(CHUBB_DISABLE_DATE_TIME_PATTERN);

    if (!match) {
        return null;
    }

    const [, year, month, day, hour, minute, second] = match.map(Number);
    const dateForValidation = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    const isValidConfiguredDate = dateForValidation.getUTCFullYear() === year &&
        dateForValidation.getUTCMonth() === month - 1 &&
        dateForValidation.getUTCDate() === day &&
        dateForValidation.getUTCHours() === hour &&
        dateForValidation.getUTCMinutes() === minute &&
        dateForValidation.getUTCSeconds() === second;

    if (!isValidConfiguredDate) {
        return null;
    }

    return Date.UTC(year, month - 1, day, hour - HKT_OFFSET_HOURS, minute, second);
};

export const isChubbFunctionDisableEffective = (currentDate = new Date()) => {
    const effectiveTimeUtc = getChubbFunctionDisableTimeUtc();

    if (effectiveTimeUtc === null || Number.isNaN(currentDate?.getTime())) {
        return false;
    }

    return currentDate.getTime() >= effectiveTimeUtc;
};

export const useChubbFunctionDisableEffective = () => {
    const [isEffective, setIsEffective] = useState(() => isChubbFunctionDisableEffective());
    const [rescheduleCount, setRescheduleCount] = useState(0);

    useEffect(() => {
        if (isEffective) {
            return undefined;
        }

        const effectiveTimeUtc = getChubbFunctionDisableTimeUtc();

        if (effectiveTimeUtc === null) {
            return undefined;
        }

        const delay = effectiveTimeUtc - Date.now();

        if (delay <= 0) {
            setIsEffective(true);
            return undefined;
        }

        const timerId = setTimeout(() => {
            if (isChubbFunctionDisableEffective()) {
                setIsEffective(true);
            } else {
                setRescheduleCount((count) => count + 1);
            }
        }, Math.min(delay, MAX_TIMEOUT_MS));

        return () => clearTimeout(timerId);
    }, [isEffective, rescheduleCount]);

    return isEffective;
};